import { VerticalSystemModule } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';
import { toSysId } from 'services/cms/typesUtil';
import { VerticalSystemTabItem } from './types';

export function getVerticalSystemTabItems({
  items: tabs = [],
  item1,
  item1Icon,
  item2,
  item2Icon,
  item3,
  item3Icon,
  item4,
  item4Icon,
}: FlatEntry<VerticalSystemModule>): VerticalSystemTabItem[] {
  return tabs.map(tab => ({
    id: toSysId(tab) ?? `${tab.title}`,
    title: tab.title,
    link: tab.link,
    items: [
      {
        description: tab.item1Description,
        icon: item1Icon,
        itemTitle: item1,
        link: tab.item1Link,
        title: tab.item1Title,
        variant: 'item1',
      },
      {
        description: tab.item2Description,
        icon: item2Icon,
        itemTitle: item2,
        link: tab.item2Link,
        title: tab.item2Title,
        variant: 'item2',
      },
      {
        description: tab.item3Description,
        icon: item3Icon,
        itemTitle: item3,
        link: tab.item3Link,
        title: tab.item3Title,
        variant: 'item3',
      },
      {
        description: tab.item4Description,
        icon: item4Icon,
        itemTitle: item4,
        link: tab.item4Link,
        title: tab.item4Title,
        variant: 'item4',
      },
    ],
  }));
}
